/* FA clip player v3 — self-hosted <video> with YouTube-shaped controls.

   Why this exists: v1 and v2 embedded YouTube, and a cross-origin iframe can
   never go truly fullscreen on iPhone. Element.requestFullscreen does not exist
   there (MDN: iOS support is iPad-only), and a CSS rotate is not fullscreen —
   Safari's URL bar and toolbar stay on screen. The only real route is
   HTMLVideoElement.webkitEnterFullscreen, which needs a SAME-ORIGIN <video>.
   So the clips are now our own files, and this drives them directly.

   Two things fall out of owning the file, both of which the embed could not do:
   - the skipped middles are cut at encode time, so there is nothing for a
     viewer to scrub into;
   - no YouTube title bar and no "More videos" grid of competitor thumbnails.

   The "Watch on YouTube" link still lands on the creator's real video at the
   moment you are actually at — the removed gaps are added back with toAbs(),
   so relative time in our file maps to absolute time in theirs. */
(function(){
  if(window.__rvc4Loaded) return;
  window.__rvc4Loaded = 1;

  var ICON = {
    play:'<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>',
    pause:'<svg viewBox="0 0 24 24" fill="currentColor"><path d="M6 5h4v14H6zM14 5h4v14h-4z"/></svg>',
    prev:'<svg viewBox="0 0 24 24" fill="currentColor"><path d="M7 6h2v12H7zm3 6l8-6v12z"/></svg>',
    next:'<svg viewBox="0 0 24 24" fill="currentColor"><path d="M15 6h2v12h-2zM6 6l8 6-8 6z"/></svg>',
    vol:'<svg viewBox="0 0 24 24" fill="currentColor"><path d="M4 9v6h4l5 4V5L8 9H4zm12.5 3a4.5 4.5 0 0 0-2.5-4v8a4.5 4.5 0 0 0 2.5-4z"/></svg>',
    mute:'<svg viewBox="0 0 24 24" fill="currentColor"><path d="M4 9v6h4l5 4V5L8 9H4zm15.7-.3-1.4-1.4L16 9.6l-2.3-2.3-1.4 1.4L14.6 11l-2.3 2.3 1.4 1.4L16 12.4l2.3 2.3 1.4-1.4L17.4 11z"/></svg>',
    gear:'<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm9 4a7 7 0 0 1-.1 1.2l2.1 1.6-2 3.5-2.5-1a7.4 7.4 0 0 1-2 1.2l-.4 2.6h-4l-.4-2.6a7.4 7.4 0 0 1-2-1.2l-2.5 1-2-3.5L3.1 13a7.3 7.3 0 0 1 0-2.4L1 9l2-3.5 2.5 1a7.4 7.4 0 0 1 2-1.2L8 2.7h4l.4 2.6c.7.3 1.4.7 2 1.2l2.5-1 2 3.5-2.1 1.6c.1.4.2.8.2 1.4z"/></svg>',
    full:'<svg viewBox="0 0 24 24" fill="currentColor"><path d="M4 9V4h5v2H6v3H4zm11-5h5v5h-2V6h-3V4zM4 15h2v3h3v2H4v-5zm14 0h2v5h-5v-2h3v-3z"/></svg>',
    exit:'<svg viewBox="0 0 24 24" fill="currentColor"><path d="M9 4v3H6V4H4v5h5V4zm6 0v5h5V7h-3V4h-2zM4 15h5v5H7v-3H4v-2zm11 5v-5h5v2h-3v3h-2z"/></svg>',
    back10:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9l5 4"/><path d="M6 9h7a6 6 0 1 1-6 6"/></svg>',
    fwd10:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m13 5 5 4-5 4"/><path d="M18 9h-7a6 6 0 1 0 6 6"/></svg>'
  };
  var LOGO = '<svg viewBox="0 0 28 20" fill="none" aria-hidden="true"><rect width="28" height="20" rx="5" fill="#FF0000"/><path d="M11 6l7 4-7 4V6z" fill="#fff"/></svg>';

  var TOUCH = !!(window.matchMedia && window.matchMedia('(hover:none)').matches);
  /* iPadOS reports MacIntel, hence the maxTouchPoints leg */
  var IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var RATES = [0.75, 1, 1.25, 1.5, 1.75, 2];

  var md = document.createElement('div');
  md.id = 'rvc3-modal';
  md.className = 'rvc3-md' + (TOUCH ? ' touch' : '');
  md.setAttribute('role', 'dialog');
  md.setAttribute('aria-modal', 'true');
  md.setAttribute('aria-label', 'Video player');
  md.innerHTML = '<div class="rvc3-in">' +
    '<video class="rvc3-v" data-v playsinline preload="metadata" ' +
      'x-webkit-airplay="allow" controlslist="nodownload"></video>' +
    '<div class="rvc3-rip l" data-ripl><span>' + ICON.back10 + '10 seconds</span></div>' +
    '<div class="rvc3-rip r" data-ripr><span>' + ICON.fwd10 + '10 seconds</span></div>' +
    '<div class="rvc3-spin"></div>' +
    '<button class="rvc3-big" data-big aria-label="Play">' + ICON.play + '</button>' +
    '<div class="rvc3-next" data-next></div>' +
    '<div class="rvc3-top">' +
      '<div class="rvc3-ch" data-ch></div>' +
      '<span class="rvc3-count" data-count></span>' +
      '<a class="rvc3-yt" data-yt target="_blank" rel="noopener"></a>' +
      '<button class="rvc3-x" data-x aria-label="Close">&times;</button>' +
    '</div>' +
    '<div class="rvc3-bot">' +
      '<div class="rvc3-bar" data-bar role="slider" tabindex="0" aria-label="Seek">' +
        '<i></i><div class="rvc3-buf" data-buf></div>' +
        '<div class="rvc3-fill" data-fill></div><div class="rvc3-dot" data-dot></div></div>' +
      '<div class="rvc3-row">' +
        '<button class="rvc3-b" data-pp aria-label="Play">' + ICON.play + '</button>' +
        '<button class="rvc3-b" data-prev aria-label="Previous clip">' + ICON.prev + '</button>' +
        '<button class="rvc3-b" data-nextb aria-label="Next clip">' + ICON.next + '</button>' +
        '<span class="rvc3-vol"><button class="rvc3-b" data-mute aria-label="Mute">' + ICON.vol + '</button>' +
          '<input type="range" min="0" max="1" step="0.05" value="1" data-volr aria-label="Volume"></span>' +
        '<span class="rvc3-time"><span data-cur>0:00</span> / <span data-tot>0:00</span></span>' +
        '<span class="rvc3-rate rvc3-sp">' +
          '<button class="rvc3-b" data-gear aria-label="Playback speed">' + ICON.gear + '</button>' +
          '<div class="rvc3-menu" data-menu></div></span>' +
        '<button class="rvc3-b" data-fs aria-label="Full screen">' + ICON.full + '</button>' +
      '</div>' +
    '</div></div>';
  document.body.appendChild(md);

  function q(s){ return md.querySelector(s); }

  /* ?rvcdebug=1 pins the last media/fullscreen events on screen. iOS exiting
     fullscreen on its own is invisible from here — this makes one screen
     recording enough to say WHY rather than guess. */
  var DEBUG = /[?&]rvcdebug=1/.test(location.search), dbgEl = null, dbgT0 = 0;
  var LOGBUF = [], logT0 = Date.now();
  function log(msg){
    LOGBUF.push(((Date.now() - logT0) / 1000).toFixed(1) + ' ' + msg);
    if(LOGBUF.length > 60) LOGBUF.shift();
    dbg(msg);
  }
  function beacon(why){
    try{
      var payload = JSON.stringify({
        why: why, t: Date.now(), url: location.pathname + location.search,
        ua: navigator.userAgent.slice(0, 140),
        vid: cur ? cur.vid : null,
        pos: (function(){ try{ return +V.currentTime.toFixed(1); }catch(e){ return null; } })(),
        events: LOGBUF.slice(-40)
      });
      navigator.sendBeacon('https://cs.freakathlete.net/api/clip-log',
                           new Blob([payload], { type: 'text/plain' }));
    }catch(e){}
  }
  function dbg(msg){
    if(!DEBUG) return;
    if(!dbgEl){
      dbgEl = document.createElement('div');
      dbgEl.style.cssText = 'position:absolute;left:6px;top:6px;z-index:99;max-width:70%;' +
        'font:600 10px/1.35 ui-monospace,Menlo,monospace;color:#0f0;background:rgba(0,0,0,.72);' +
        'padding:6px 7px;border-radius:5px;pointer-events:none;white-space:pre-wrap';
      md.appendChild(dbgEl); dbgT0 = Date.now();
    }
    var line = ((Date.now() - dbgT0) / 1000).toFixed(1) + 's ' + msg;
    dbgEl.textContent = (line + '\n' + dbgEl.textContent).split('\n').slice(0, 14).join('\n');
  }
  var guardUntil = 0;
  function guardClicks(ms){ guardUntil = Date.now() + (ms || 500); }
  function guarded(){ return Date.now() < guardUntil; }
  var V = q('[data-v]'), bar = q('[data-bar]'), shell = q('.rvc3-in');
  var CARDS = [], idx = 0, cur = null, lastCard = null, resumeAt = 0;
  window.__rvc3Pos = window.__rvc3Pos || {};   /* vid -> position, for resume */
  var idleT = null, nextT = null, pushed = false, savedY = 0, dragging = false;

  function fmt(s){
    s = Math.max(0, s || 0);
    return Math.floor(s / 60) + ':' + String(Math.floor(s % 60)).padStart(2, '0');
  }

  /* The delivered file has the skipped middles removed, so its clock runs on
     RELATIVE time. The creator's video runs on ABSOLUTE time. toAbs adds the
     gaps back, which is what makes "Watch on YouTube" land on the same moment
     the viewer is looking at rather than the top of the clip. */
  function segments(start, end, skips){
    var gaps = (skips || '').split(',').filter(Boolean).map(function(p){
      var ab = p.split('-'); return [+ab[0], +ab[1]];
    }).filter(function(g){ return g[1] > g[0]; }).sort(function(a, b){ return a[0] - b[0]; });
    var segs = [], c = start;
    gaps.forEach(function(g){
      if(g[1] <= c || g[0] >= end) return;
      if(g[0] > c) segs.push([c, Math.min(g[0], end)]);
      c = Math.max(c, g[1]);
    });
    if(c < end) segs.push([c, end]);
    return segs.length ? segs : [[start, end]];
  }
  function toAbs(r){
    var acc = 0, S = cur.segs;
    for(var i = 0; i < S.length; i++){
      var L = S[i][1] - S[i][0];
      if(r < acc + L || i === S.length - 1) return S[i][0] + Math.max(0, Math.min(L, r - acc));
      acc += L;
    }
    return cur.end;
  }

  /* ── chrome visibility ────────────────────────────────────────────────── */
  function wake(){
    md.classList.remove('idle');
    if(idleT){ clearTimeout(idleT); idleT = null; }
    if(!V.paused && !dragging) idleT = setTimeout(function(){
      idleT = null;
      if(!V.paused && !dragging && !q('[data-menu]').classList.contains('on'))
        md.classList.add('idle');
    }, 3000);
  }

  /* ── painting ─────────────────────────────────────────────────────────── */
  function paint(){
    var d = V.duration || (cur && cur.dur) || 0;
    var pc = d ? Math.max(0, Math.min(1, V.currentTime / d)) * 100 : 0;
    q('[data-fill]').style.width = pc + '%';
    q('[data-dot]').style.left = pc + '%';
    q('[data-cur]').textContent = fmt(V.currentTime);
    if(d) q('[data-tot]').textContent = fmt(d);
    bar.setAttribute('aria-valuemin', '0');
    bar.setAttribute('aria-valuemax', Math.round(d));
    bar.setAttribute('aria-valuenow', Math.round(V.currentTime));
    bar.setAttribute('aria-valuetext', fmt(V.currentTime) + ' of ' + fmt(d));
    if(cur){
      var a = q('[data-yt]');
      a.href = 'https://www.youtube.com/watch?v=' + cur.vid +
               '&t=' + Math.floor(toAbs(V.currentTime)) + 's';
    }
  }
  function paintBuf(){
    try{
      if(!V.buffered.length || !V.duration) return;
      var end = V.buffered.end(V.buffered.length - 1);
      q('[data-buf]').style.width = (end / V.duration * 100) + '%';
    }catch(e){}
  }
  function icon(){
    var s = V.paused ? ICON.play : ICON.pause;
    q('[data-pp]').innerHTML = s;
    q('[data-pp]').setAttribute('aria-label', V.paused ? 'Play' : 'Pause');
    md.classList.toggle('paused', V.paused);
  }

  /* ── transport ────────────────────────────────────────────────────────── */
  function toggle(){ if(V.paused) V.play(); else V.pause(); wake(); }
  function seekBy(d){
    if(!V.duration) return;
    V.currentTime = Math.max(0, Math.min(V.duration - 0.05, V.currentTime + d));
    var r = q(d < 0 ? '[data-ripl]' : '[data-ripr]');
    r.classList.add('on');
    setTimeout(function(){ r.classList.remove('on'); }, 420);
    paint(); wake();
  }

  /* ── YouTube fallback overlay ─────────────────────────────────────────── */
  var ytBox = null;
  function ytFallback(d){
    if(!d.vid) return;
    ytClose();
    ytBox = document.createElement('div');
    ytBox.setAttribute('data-rvc-yt','');
    ytBox.style.cssText = 'position:fixed;inset:0;z-index:2147483000;background:rgba(8,10,12,.94);' +
      'display:flex;align-items:center;justify-content:center;padding:24px';
    var wrap = document.createElement('div');
    wrap.style.cssText = 'position:relative;width:100%;max-width:1100px;aspect-ratio:16/9;' +
      'background:#000;border-radius:10px;overflow:hidden';
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + d.vid + '?autoplay=1&rel=0&playsinline=1';
    f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
    f.allowFullscreen = true;
    f.setAttribute('title', (d.ch || 'Review') + ' video');
    f.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0';
    var x = document.createElement('button');
    x.type = 'button';
    x.setAttribute('aria-label','Close video');
    x.innerHTML = '&times;';
    x.style.cssText = 'position:fixed;top:16px;right:16px;width:42px;height:42px;border:0;' +
      'border-radius:50%;background:rgba(255,255,255,.92);color:#11171b;font-size:26px;line-height:1;' +
      'cursor:pointer;display:flex;align-items:center;justify-content:center;' +
      'box-shadow:0 3px 14px rgba(0,0,0,.45)';
    x.addEventListener('click', ytClose);
    wrap.appendChild(f); ytBox.appendChild(wrap); ytBox.appendChild(x);
    ytBox.addEventListener('click', function(e){ if(e.target === ytBox) ytClose(); });
    document.addEventListener('keydown', ytKey);
    document.body.appendChild(ytBox);
    document.body.style.overflow = 'hidden';
    x.focus();
  }
  function ytKey(e){ if(e.key === 'Escape') ytClose(); }
  function ytClose(){
    if(!ytBox) return;
    document.removeEventListener('keydown', ytKey);
    ytBox.remove(); ytBox = null;
    document.body.style.overflow = '';
  }

  function open(i){
    if(!CARDS.length) return;
    if(nextT){ clearTimeout(nextT); nextT = null; }
    idx = ((i % CARDS.length) + CARDS.length) % CARDS.length;
    var d = CARDS[idx].dataset;
    /* No hosted cut yet (a card added before its mp4 exists): fall back to a
       plain YouTube overlay so the card still plays instead of doing nothing.
       Never fires once mp4_url is filled in — the real player takes over.
       The card's duration chip shows the PLANNED cut; the fallback plays the
       creator's full video. Preview-only, 2026-09-02 (ABX videos trial). */
    if(!d.mp4){ ytFallback(d); return; }
    var segs = segments(+d.start, +d.end, d.skips);
    cur = { vid: d.vid, start: segs[0][0], end: +d.end, segs: segs,
            dur: segs.reduce(function(a, s){ return a + (s[1] - s[0]); }, 0) };
    q('[data-ch]').innerHTML = (d.ch || '') +
      '<small>' + [d.views, d.caption].filter(Boolean).join(' &middot; ') + '</small>';
    q('[data-count]').textContent = (idx + 1) + ' / ' + CARDS.length;
    q('[data-next]').classList.remove('on');
    var a = q('[data-yt]');
    a.innerHTML = LOGO + '<span>YouTube</span>';
    a.href = 'https://www.youtube.com/watch?v=' + d.vid + '&t=' + Math.floor(cur.start) + 's';
    q('[data-tot]').textContent = fmt(cur.dur);
    q('[data-buf]').style.width = '0%';

    var first = !md.classList.contains('on');
    if(first){ lockBody(); pushHist(); md.classList.add('on'); }
    if(d.poster) V.poster = d.poster;
    /* Prefer HLS where the browser has it natively (Safari, and therefore every
       iPhone). iOS drops OUT of webkitEnterFullscreen when the media stalls, so
       a single big progressive mp4 on a weak connection kicks the viewer back to
       the inline player a second or two after they go fullscreen. HLS steps down
       a rendition instead of stalling. Chrome and Firefox have no native HLS, so
       they fall through to the mp4. */
    while(V.firstChild) V.removeChild(V.firstChild);
    V.removeAttribute('src');
    function addSource(url, type){
      if(!url) return;
      var el = document.createElement('source');
      el.src = url; el.type = type; V.appendChild(el);
    }
    var canHls = !!(V.canPlayType('application/vnd.apple.mpegurl') ||
                    V.canPlayType('application/x-mpegURL'));
    if(canHls) addSource(d.hls, 'application/vnd.apple.mpegurl');
    addSource(d.mp4, 'video/mp4');
    V.load();
    /* seeking before loadedmetadata throws InvalidStateError in Safari, so the
       resume position is applied in the loadedmetadata listener instead */
    resumeAt = window.__rvc3Pos[d.vid] || 0;
    V.playbackRate = window.__rvc3Rate || 1;
    paint(); icon(); wake();
    var p = V.play();
    if(p && p.catch) p.catch(function(){ icon(); });
    if(first) setTimeout(function(){ q('[data-x]').focus(); }, 60);
  }

  function close(reason){
    var fromPop = reason === 'back' || reason === true;
    log('close:' + reason); beacon('close-' + reason);
    try{ sessionStorage.removeItem('rvc3_restore'); }catch(e){}
    try{ if(cur && V.currentTime > 1 && V.duration && V.currentTime < V.duration - 2)
           window.__rvc3Pos[cur.vid] = V.currentTime;
         else if(cur) delete window.__rvc3Pos[cur.vid]; }catch(e){}
    if(nextT){ clearTimeout(nextT); nextT = null; }
    if(idleT){ clearTimeout(idleT); idleT = null; }
    try{ V.pause(); }catch(e){}
    while(V.firstChild) V.removeChild(V.firstChild);
    V.removeAttribute('src'); V.load();
    md.classList.remove('on', 'idle', 'paused', 'buffering');
    q('[data-menu]').classList.remove('on');
    if(document.fullscreenElement){ try{ document.exitFullscreen(); }catch(e){} }
    cur = null; dragging = false;
    unlockBody();
    if(!fromPop && pushed){ pushed = false; try{ history.back(); }catch(e){} }
    pushed = false;
    if(lastCard){ try{ lastCard.focus(); }catch(e){} lastCard = null; }
  }

  /* the page must not scroll under an open player */
  function lockBody(){
    savedY = window.scrollY || document.documentElement.scrollTop || 0;
    var b = document.body; b.dataset.rvc3Lock = '1';
    b.style.position = 'fixed'; b.style.top = (-savedY) + 'px';
    b.style.overscrollBehavior = 'none';
    document.documentElement.style.overscrollBehavior = 'none';
    b.style.left = '0'; b.style.right = '0'; b.style.width = '100%'; b.style.overflow = 'hidden';
  }
  function unlockBody(){
    var b = document.body; if(b.dataset.rvc3Lock !== '1') return;
    delete b.dataset.rvc3Lock;
    b.style.position = ''; b.style.top = ''; b.style.left = '';
    b.style.overscrollBehavior = '';
    document.documentElement.style.overscrollBehavior = '';
    b.style.right = ''; b.style.width = ''; b.style.overflow = '';
    window.scrollTo(0, savedY);
  }
  function pushHist(){
    /* Never on iOS (Safari OR Chrome — CriOS is WebKit underneath). The pushed
       entry is what a back-swipe "goes back" to, and Chrome iOS commits that
       gesture as a FULL PAGE RELOAD of the previous entry — same URL, cookie
       banner back, player gone, position lost. No popstate handler runs,
       because the document itself is being replaced. With no pushed entry
       there is nothing to land on: a viewer who opened the PDP directly gets a
       rubber-band, nothing more. Android keeps the entry so its real back
       button closes the player. */
    if(IOS || pushed) return;
    try{ history.pushState({ rvc3: 1 }, ''); pushed = true; }catch(e){}
  }
  window.addEventListener('popstate', function(){
    if(!md.classList.contains('on')) return;
    /* iPhone has NO back button, so every popstate that arrives while the
       player is open is Safari's edge back-swipe — and a scrub or tap that
       strays into the edge zone triggers it. Worse, when Safari steals the
       gesture it CANCELS our pointer events first, so a "finger down" guard
       sees nothing: this is exactly how the player kept closing itself on
       Benji's phone (recording, 2026-08-10: inline playback at 0:50, next
       frame the page grid). On iOS, ignore popstate and re-arm — the X is the
       close. Android's back is a real button and keeps closing the player. */
    if(IOS){ log('popstate-ignored'); return; }
    if(dragging || Date.now() < guardUntil){
      pushed = false; pushHist(); log('popstate-rearmed'); return;
    }
    pushed = false; close('back');
  });

  /* ── fullscreen: the whole reason for self-hosting ─────────────────────
     iPhone has no Fullscreen API for elements, but a SAME-ORIGIN <video> can
     call webkitEnterFullscreen(), which opens the real iOS player — browser
     chrome gone, device auto-rotates. Try the standard API first so desktop
     and Android keep our own chrome, and fall back to the native handoff. */
  function nativeFS(){
    if(V.webkitEnterFullscreen){
      try{ V.webkitEnterFullscreen(); return true; }catch(e){}
    }
    if(V.webkitSupportsFullscreen && V.webkitEnterFullScreen){
      try{ V.webkitEnterFullScreen(); return true; }catch(e){}
    }
    return false;
  }
  function toggleFS(){
    if(document.fullscreenElement){ try{ document.exitFullscreen(); }catch(e){} wake(); return; }
    /* On a touch device go straight to the native player. Apple's ELEMENT
       fullscreen is hostile to touch: MDN's compat notes say it "shows an
       overlay button which can not be disabled" and that "swiping down exits
       fullscreen mode". A scrub drag has vertical travel, so it reads as a
       swipe-down and drops out of fullscreen mid-drag; a tap can hit the
       overlay button. The native video player has neither problem, and its own
       scrubber is the one people already know. */
    if(TOUCH && nativeFS()) return;
    if(document.fullscreenEnabled && shell.requestFullscreen){
      var p;
      try{ p = shell.requestFullscreen(); }catch(e){ nativeFS(); }
      if(p && p.catch) p.catch(function(){ nativeFS(); });
    } else {
      nativeFS();
    }
    wake();
  }
  /* Leaving fullscreen re-lays the page out, and the synthesized click that
     follows a tap arrives AFTER that — landing on whatever now occupies the
     spot. Top-right is the close button, so a tap to leave fullscreen was
     tearing the whole player down. Swallow clicks for a beat either side. */
  document.addEventListener('fullscreenchange', function(){
    guardClicks();
    q('[data-fs]').innerHTML = document.fullscreenElement ? ICON.exit : ICON.full;
    wake();
  });
  V.addEventListener('webkitbeginfullscreen', function(){ guardClicks(); log('FS-in'); });
  V.addEventListener('webkitendfullscreen', function(){
    guardClicks(700); wake();
    log('FS-out net=' + (navigator.connection && navigator.connection.effectiveType || '?') +
        ' ahead=' + bufAhead().toFixed(1));
    /* iOS force-pauses the video on leaving native fullscreen, which lands the
       viewer back inline frozen — it reads as "it stopped again" (every FS-out
       in the 2026-08-10 telemetry shows the pause). The element already earned
       its gesture activation, so a programmatic resume is allowed; if a future
       iOS refuses it, the catch leaves the normal paused UI. */
    setTimeout(function(){
      if(md.classList.contains('on') && V.paused && !V.ended){
        var p = V.play(); if(p && p.catch) p.catch(function(){});
        log('FS-out auto-resume');
      }
    }, 60);
  });
  function bufAhead(){
    try{
      for(var i = 0; i < V.buffered.length; i++)
        if(V.currentTime >= V.buffered.start(i) - 0.2 && V.currentTime <= V.buffered.end(i))
          return V.buffered.end(i) - V.currentTime;
    }catch(e){}
    return 0;
  }
  ['stalled','waiting','suspend','emptied','abort','error','ended','pause','play','seeking','seeked']
    .forEach(function(ev){
      V.addEventListener(ev, function(){
        log(ev + ' t=' + V.currentTime.toFixed(1) + ' ahead=' + bufAhead().toFixed(1) +
            (ev === 'error' && V.error ? ' code=' + V.error.code : ''));
      });
    });

  /* ── scrubbing: one pointer path, so touch and mouse cannot diverge ──── */
  function fracAt(ev){
    var r = bar.getBoundingClientRect();
    return Math.max(0, Math.min(1, (ev.clientX - r.left) / r.width));
  }
  function scrub(ev){
    if(!V.duration) return;
    V.currentTime = fracAt(ev) * V.duration;
    paint();
  }
  bar.addEventListener('pointerdown', function(ev){
    dragging = true; bar.classList.add('drag');
    try{ bar.setPointerCapture(ev.pointerId); }catch(e){}
    md.classList.remove('idle'); scrub(ev); ev.preventDefault();
  });
  bar.addEventListener('pointermove', function(ev){ if(dragging){ scrub(ev); ev.preventDefault(); } });
  function endScrub(ev){
    if(!dragging) return;
    dragging = false; bar.classList.remove('drag');
    try{ bar.releasePointerCapture(ev.pointerId); }catch(e){}
    scrub(ev);
    /* a drag that ends over another control must not also activate it */
    guardClicks(350);
    if(ev.cancelable) ev.preventDefault();
    wake();
  }
  bar.addEventListener('pointerup', endScrub);
  bar.addEventListener('pointercancel', endScrub);

  /* ── taps on the picture ──────────────────────────────────────────────
     Touch: one tap shows or hides the chrome, double tap on a side seeks
     +/-10s — exactly what the YouTube app does. Mouse: click plays/pauses,
     double click goes fullscreen. */
  var clickT = null, lastTap = 0;
  V.addEventListener('click', function(ev){
    if(TOUCH) return;                       /* touch is handled below */
    if(clickT) return;
    clickT = setTimeout(function(){ clickT = null; toggle(); }, 230);
  });
  V.addEventListener('dblclick', function(ev){
    if(TOUCH) return;
    ev.preventDefault(); clearTimeout(clickT); clickT = null; toggleFS();
  });
  V.addEventListener('pointerup', function(ev){
    if(!TOUCH || ev.pointerType !== 'touch') return;
    var now = Date.now();
    if(now - lastTap < 300){
      lastTap = 0;
      var r = V.getBoundingClientRect();
      seekBy((ev.clientX - r.left) / r.width < 0.5 ? -10 : 10);
    } else {
      lastTap = now;
      setTimeout(function(){
        if(lastTap === 0) return;           /* a double tap consumed it */
        if(md.classList.contains('idle')) wake(); else md.classList.add('idle');
      }, 300);
    }
  });

  /* ── media events ─────────────────────────────────────────────────────── */
  /* Checkpoint every ~2s while open. If the browser replaces the page under us
     (Chrome iOS commits an edge back-swipe as a full page RELOAD — no popstate,
     no pagehide handler is guaranteed to finish), the next load reopens the
     player right where it was. The unpreventable becomes a blip, not a loss. */
  var ckLast = 0;
  function checkpoint(){
    if(!md.classList.contains('on') || !cur) return;
    var now = Date.now(); if(now - ckLast < 2000) return; ckLast = now;
    try{ sessionStorage.setItem('rvc3_restore', JSON.stringify(
      { vid: cur.vid, t: +V.currentTime.toFixed(1), ts: now })); }catch(e){}
  }
  window.addEventListener('pagehide', function(){
    if(md.classList.contains('on')){ ckLast = 0; checkpoint(); beacon('pagehide-while-open'); }
  });
  V.addEventListener('timeupdate', function(){ paint(); checkpoint(); });
  V.addEventListener('progress', paintBuf);
  V.addEventListener('loadedmetadata', function(){
    if(resumeAt > 1 && V.duration && resumeAt < V.duration - 2){
      try{ V.currentTime = resumeAt; }catch(e){}
    }
    resumeAt = 0; paint(); paintBuf();
  });
  V.addEventListener('play', function(){ icon(); md.classList.remove('buffering'); wake(); });
  V.addEventListener('pause', function(){ icon(); wake(); });
  V.addEventListener('waiting', function(){ md.classList.add('buffering'); });
  V.addEventListener('playing', function(){ md.classList.remove('buffering'); });
  V.addEventListener('canplay', function(){ md.classList.remove('buffering'); });
  V.addEventListener('ended', function(){
    try{ if(cur) delete window.__rvc3Pos[cur.vid]; }catch(e){}
    icon();
    if(CARDS.length < 2){ wake(); return; }
    var n = CARDS[(idx + 1) % CARDS.length].dataset;
    var el = q('[data-next]');
    el.innerHTML = '<em>UP NEXT</em>' + (n.ch || '') + (n.caption ? '<br>' + n.caption : '');
    el.classList.add('on');
    md.classList.remove('idle');
    nextT = setTimeout(function(){ nextT = null; open(idx + 1); }, 1400);
  });

  /* ── controls ─────────────────────────────────────────────────────────── */
  q('[data-pp]').onclick = toggle;
  q('[data-big]').onclick = toggle;
  q('[data-prev]').onclick = function(){ open(idx - 1); };
  q('[data-nextb]').onclick = function(){ open(idx + 1); };
  q('[data-fs]').onclick = toggleFS;
  /* A tap made on the NATIVE fullscreen player's controls can materialize in
     our DOM ~300ms later as a bare click with no pointerdown — and wherever it
     lands is whatever now occupies those coordinates, which top-right is this
     button. A real press always delivers pointerdown first; a keyboard
     activation has ev.detail === 0. Everything else is a ghost. */
  var xDownAt = 0, xEl = q('[data-x]');
  xEl.addEventListener('pointerdown', function(){ xDownAt = Date.now(); });
  xEl.onclick = function(ev){
    /* a keyboard activation reports detail 0 — but so can an iOS ghost click,
       so the exemption also requires the button to actually hold focus */
    var keyboard = ev && ev.detail === 0 && document.activeElement === xEl;
    if(!keyboard){
      if(guarded()){ log('x-ghost-guard'); return; }
      if(Date.now() - xDownAt > 1200){ log('x-ghost-nopress'); return; }
    }
    close('x');
  };
  q('[data-mute]').onclick = function(){
    V.muted = !V.muted;
    q('[data-mute]').innerHTML = V.muted ? ICON.mute : ICON.vol;
    q('[data-volr]').value = V.muted ? 0 : V.volume;
    wake();
  };
  q('[data-volr]').oninput = function(){
    V.volume = +this.value; V.muted = (+this.value === 0);
    q('[data-mute]').innerHTML = V.muted ? ICON.mute : ICON.vol;
    wake();
  };

  window.__rvc3Rate = window.__rvc3Rate || 1;
  var menu = q('[data-menu]');
  function paintMenu(){
    menu.innerHTML = RATES.map(function(r){
      return '<button role="menuitemradio" data-r="' + r + '" aria-checked="' +
        (r === window.__rvc3Rate) + '">' + (r === 1 ? 'Normal' : r + '×') + '</button>';
    }).join('');
    menu.querySelectorAll('button').forEach(function(b){
      b.onclick = function(){
        window.__rvc3Rate = +b.dataset.r;
        V.playbackRate = window.__rvc3Rate;
        paintMenu(); menu.classList.remove('on'); wake();
      };
    });
  }
  paintMenu();
  q('[data-gear]').onclick = function(e){ e.stopPropagation(); menu.classList.toggle('on'); wake(); };
  md.addEventListener('click', function(e){
    if(!e.target.closest('.rvc3-rate')) menu.classList.remove('on');
  });
  md.addEventListener('mousemove', wake);
  md.addEventListener('touchmove', function(e){
    if(e.cancelable) e.preventDefault();
  }, { passive: false });

  document.addEventListener('keydown', function(e){
    if(!md.classList.contains('on')) return;
    var k = e.key;
    if(k === 'Escape'){
      if(document.fullscreenElement){ try{ document.exitFullscreen(); }catch(err){} }
      else close('esc');
      return;
    }
    if(k === ' ' || k === 'k'){ e.preventDefault(); toggle(); return; }
    if(k === 'ArrowRight'){ e.preventDefault(); seekBy(5); return; }
    if(k === 'ArrowLeft'){ e.preventDefault(); seekBy(-5); return; }
    if(k === 'l'){ seekBy(10); return; }
    if(k === 'j'){ seekBy(-10); return; }
    if(k === 'f'){ toggleFS(); return; }
    if(k === 'm'){ q('[data-mute]').click(); return; }
    if(k === 'n'){ open(idx + 1); return; }
    if(k === 'p'){ open(idx - 1); return; }
    if(k !== 'Tab') return;
    var f = [].slice.call(md.querySelectorAll('button,a[href],input,[tabindex="0"]'))
             .filter(function(n){ return n.offsetWidth || n.offsetHeight; });
    if(!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  });

  /* ── native mode ──────────────────────────────────────────────────────
     Option A (Benji, 2026-08-10): on a phone there is NO modal of ours at all.
     A <video> without the playsinline attribute auto-opens the native iOS
     player, fullscreen, on play() — inside the tap gesture, so it is allowed.
     iOS owns scrubbing, fullscreen and Done; when the viewer is done there is
     nothing of ours on screen to tear down, reload, or restore. The whole
     class of modal failures is deleted rather than defended against.
     Desktop keeps the custom player below. */
  var NV = null, nIdx = 0, nCards = [];
  function nativeVideo(){
    if(NV) return NV;
    NV = document.createElement('video');
    /* no playsinline -> iPhone plays fullscreen in the native player */
    NV.setAttribute('controls', '');
    NV.setAttribute('preload', 'metadata');
    NV.style.cssText = 'position:fixed;left:0;bottom:0;width:2px;height:2px;opacity:0.01;pointer-events:none;z-index:1';
    document.body.appendChild(NV);
    NV.addEventListener('webkitbeginfullscreen', function(){ log('nFS-in'); });
    NV.addEventListener('webkitendfullscreen', function(){
      log('nFS-out t=' + NV.currentTime.toFixed(1));
      try{ if(nCards[nIdx] && NV.currentTime > 1 && NV.duration &&
              NV.currentTime < NV.duration - 2)
             window.__rvc3Pos[nCards[nIdx].dataset.vid] = NV.currentTime; }catch(e){}
      try{ NV.pause(); }catch(e){}
      beacon('native-done');
    });
    NV.addEventListener('error', function(){
      log('nERROR code=' + (NV.error && NV.error.code)); beacon('native-error');
    });
    NV.addEventListener('ended', function(){
      log('n-ended');
      /* roll on to the next clip; the element keeps its gesture activation,
         and iOS keeps the native player up while the new source plays */
      if(nCards.length > 1){ nIdx = (nIdx + 1) % nCards.length; nLoad(true); }
    });
    return NV;
  }
  function nLoad(autoplay){
    var d = nCards[nIdx].dataset;
    var v = nativeVideo();
    while(v.firstChild) v.removeChild(v.firstChild);
    v.removeAttribute('src');
    var canHls = !!(v.canPlayType('application/vnd.apple.mpegurl') ||
                    v.canPlayType('application/x-mpegURL'));
    function src(url, type){ if(!url) return;
      var el = document.createElement('source'); el.src = url; el.type = type; v.appendChild(el); }
    if(canHls) src(d.hls, 'application/vnd.apple.mpegurl');
    src(d.mp4, 'video/mp4');
    if(d.poster) v.poster = d.poster;
    v.load();
    var at = window.__rvc3Pos[d.vid] || 0;
    if(at > 1){
      v.addEventListener('loadedmetadata', function once(){
        v.removeEventListener('loadedmetadata', once);
        if(v.duration && at < v.duration - 2){ try{ v.currentTime = at; }catch(e){} }
      });
    }
    log('native-open ' + d.vid + (at > 1 ? '@' + at.toFixed(0) : ''));
    if(autoplay){ var p = v.play(); if(p && p.catch) p.catch(function(e){ log('n-play-refused'); }); }
  }
  function nativeOpen(cards, i){
    nCards = cards; nIdx = i;
    nLoad(true);
  }

  /* ── per-section wiring ───────────────────────────────────────────────── */
  function initSection(root){
    if(root.dataset.rvc3Init) return;
    root.dataset.rvc3Init = '1';
    var cards = [].slice.call(root.querySelectorAll('[data-rvc-open]'));
    cards.forEach(function(b, i){
      b.addEventListener('click', function(){
        /* iOS takes its own route straight to the native player, which reads
           mp4/hls off the card. A card with no hosted cut yet has neither, so
           v.load() on an empty <source> list did nothing at all and the tap
           looked dead — the desktop fallback below never ran here. Guard the
           iOS leg too. 2026-09-02. */
        if(IOS){
          if(!b.dataset.mp4){ ytFallback(b.dataset); return; }
          nativeOpen(cards, i); return;
        }
        CARDS = cards; lastCard = b;
        md.style.setProperty('--rvc3-accent', root.dataset.accent || '#f0582b');
        open(i);
      });
    });

    /* View counts come from assets/fa-video-stats.json, refreshed daily by
       bin/youtube_view_sync.py. If the file is missing or a video isn't in it,
       whatever was typed into the block stays on screen. */
    var url = root.dataset.stats;
    if(url && url.indexOf('fa-video-stats') !== -1){
      fetch(url, { cache: 'no-cache' }).then(function(r){ return r.ok ? r.json() : null; })
        .then(function(d){
          if(!d || !d.videos) return;
          root.querySelectorAll('[data-views-for]').forEach(function(el){
            var st = d.videos[el.getAttribute('data-views-for')];
            if(st && st.views_text) el.textContent = st.views_text;
          });
        }).catch(function(){});
    }

    /* rail arrows (grid layout hides them) */
    var rail = root.querySelector('[data-rvc-rail]');
    var prev = root.querySelector('[data-rvc-prev]'), next = root.querySelector('[data-rvc-next]');
    if(!rail || !prev || !next) return;
    function stepBy(d){
      var c = rail.querySelector('.rvc-card'); if(!c) return;
      rail.scrollBy({ left: d * (c.offsetWidth + 16), behavior: 'smooth' });
    }
    next.onclick = function(){ stepBy(1); };
    prev.onclick = function(){ stepBy(-1); };
    function arrows(){
      prev.disabled = rail.scrollLeft < 8;
      next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 8;
    }
    rail.addEventListener('scroll', arrows);
    setTimeout(arrows, 150);
    window.addEventListener('resize', arrows);
  }
  function restore(){
    if(IOS) return;   /* native mode has no modal to restore */
    var r = null;
    try{ r = JSON.parse(sessionStorage.getItem('rvc3_restore') || 'null'); }catch(e){}
    if(!r || !r.vid || Date.now() - r.ts > 60000) return;
    try{ sessionStorage.removeItem('rvc3_restore'); }catch(e){}
    var card = document.querySelector('[data-rvc-open][data-vid="' + r.vid + '"]');
    if(!card) return;
    var root = card.closest('[data-rvc3]');
    var cards = [].slice.call(root.querySelectorAll('[data-rvc-open]'));
    CARDS = cards; lastCard = card;
    md.style.setProperty('--rvc3-accent', root.dataset.accent || '#f0582b');
    window.__rvc3Pos[r.vid] = r.t;
    log('restore ' + r.vid + '@' + r.t); beacon('restored');
    open(cards.indexOf(card));
    /* the reload burned the user activation, so autoplay may be refused —
       the player then sits at the right spot showing the big play button */
  }
  function bootAll(){
    document.querySelectorAll('[data-rvc3]').forEach(initSection);
    restore();
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll);
  else bootAll();
  document.addEventListener('shopify:section:load', function(){ setTimeout(bootAll, 0); });
})();
